export default __webpack_public_path__ + "static/media/18.6f402b83.jpg";